import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASUlEQVR42lWMwQrAIAxD/f+P1KEne51aKG0zT50GAkl4JOHQeAeY+Zw0RVLFUwqod7j7DYgIWm3bFTlnEBHc7AdslzlnmNeKhw8+XXy0hqzeZQAAAABJRU5ErkJggg=="};
